import axios from 'axios';

// Shared client for the Rails API.
//
// NOTE: VUE_APP_API_KEY ships inside the built bundle and is therefore visible
// to anyone who loads the page. It is a throttle against casual abuse of the
// Odds API quota, not authentication. Real per-user auth arrives with logins.
const api = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  headers: process.env.VUE_APP_API_KEY
    ? { 'X-API-KEY': process.env.VUE_APP_API_KEY }
    : {},
});

export default api;
